import type { GestureFrame } from '../types';

export function shouldOpenInstrumentGate(gesture: GestureFrame): boolean {
  return gesture.fingers.size > 0;
}
